'use strict';

import angular from 'angular';
import {
  PrefixFilter
} from './prefix.filter';

import {
  DefaultFilter
} from './default.filter';

export default angular.module('ngOskCrmApp.filter', [])
  .filter('prefix', PrefixFilter)
  .filter('default', DefaultFilter)
  .name;



// WEBPACK FOOTER //
// ./client/filter/index.js